export default {
  effectNum: 0,
  gifData: null,
  currentPage: null,
  isCapturer: false,
  ua: null,
};
